<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<style scoped lang="scss">
.effect-lists{
  //display: block!important;
  justify-content: space-between;
  flex-wrap:wrap;
  overflow: auto;
}
.cons{
  display: none;
}
.effect-lists li{
  margin-right: 30px;
  float: left;
  width: 18%;
  text-align: center;
  margin-bottom: 30px;
}
.effect-lists li:nth-last-of-type(1),.effect-lists li:nth-last-of-type(2),.effect-lists li:nth-last-of-type(3),.effect-lists li:nth-last-of-type(4),.effect-lists li:nth-last-of-type(5){
  margin-bottom: 0;
}
.effect-lists li:nth-child(5n){
  margin-right: 0;
}
@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (max-width: 414px) and (min-width: 413px),
screen and (max-width: 640px) and (min-width: 600px),
screen and (min-width: 300px) and (max-width:400px)
{
  .effect-lists{
    justify-content: flex-start!important;
  }
}
</style>
<template>
  <div class="wrap wrap-tec">
    <div class="banner">
      <img src="@/assets/img/产品及服务/常规分子项目/banner4.jpg" class="img-fluid">
      <div class="info">
<!--        <div class="container">-->
<!--          <h1>SNP检测</h1>-->
<!--          <h2 class="mt10">SNP detection</h2>-->
<!--        </div>-->
      </div>
    </div>
    <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-top: 20px;">
      <bread></bread>
    </div>
    <section class="container">
      <p class="desc">单核苷酸多态性（Single Nucleotide Polymorphisms，SNP）是指基因组上单个核苷酸的变异，人类基因组平均每1000个就有一个SNP。它是由基因组DNA某一特定核苷酸位置上单个碱基的转换、颠换、插入或缺失引起的点突变，使得群体之间和个体之间产生了差异。其中转换和颠换发生频率较高，转换是指同型碱基之间的转换，即嘌呤与嘌呤、嘧啶与嘧啶间；颠换是指发生在嘌呤与嘧啶之间的替换。</p>
      <div class="c-title">实验方案介绍<small>Introduction to experimental Methods</small></div>
      <div class="rec">直接测序法</div>
      <p class="tc mt10">测序法是检测SNP的金标准，出来检测已知SNP位点，还能发现未知SNP位点，将目标位点PCR扩增后进行测序，根据测序峰图可直观判断
        SNP的型别。</p>
      <div class="tc mt30"><img src="@/assets/images/snp_1.png"></div>
      <div class="rec mt30">Snapshot法</div>
      <div class="tc mt30"><img src="@/assets/images/snp_2.png"></div>
      <p class="tc mt20">在已知的SNP位点前设计一引物，进行单碱基（带荧光标记）延伸扩增，通过ABI3730仪器检测所延伸的碱基颜色确定SNP位点的型别； 再用软件分析，导出统计结果。</p>
      <div class="tc mt30"><img src="@/assets/images/snp_3.png"></div>
      <div class="rec mt30">探针法</div>
      <div class="tc mt30"><img src="@/assets/images/snp_4.png"></div>
      <p class="tc mt20">该方法的技术基础是荧光定量PCR，针对染色体上的不同SNP位点分别设计PCR引物和进行PCR扩增。这种方法可以直接在实验结果中读取出每个样本中SNP的基因型（纯合子XX活YY,杂合子XY），不需要再对序列进行分析，具有直观性。还可以通过软件分析出不同基因型在所有样本中的分布图。TaqMan探针法通常用于少量SNP位点分析，具有成本低、速度快的特点。</p>
      <div class="tc mt30"><img src="@/assets/images/snp_5.png"></div>
      <div class="rec mt30"> SNP检测方案选择方法</div>
      <table class="table mt30">
        <tr>
          <th>方法</th>
          <th>特点</th>
          <th>适用范围</th>
          <th>备注</th>
        </tr>
        <tr>
          <td>直接测序法</td>
          <td>SNP检测金标准，可检测未知SNP，检测速度快</td>
          <td>1-2个位点/样品检测未知SNP</td>
          <td></td>
        </tr>
        <tr>
          <td>SNaPshot法</td>
          <td>单碱基延伸，可多个位点同时检测</td>
          <td>5-10个位点/样本</td>
          <td>需要待检测位点前后200-300 bp的DNA序列</td>
        </tr>
        <tr>
          <td>探针法</td>
          <td>灵敏度高，检出率高，金标准</td>
          <td>高通量多位点检测</td>
          <td>人的SNP需要rs序列号</td>
        </tr>
      </table>
      <div class="c-title">送样要求<small>Sample Delivery Requirements</small></div>
      <el-row type="flex" align="bottom">
        <el-col :span="12">
          <img src="@/assets/images/rdna_2.png" class="img-fluid">
        </el-col>
        <el-col :span="12">
          <div class="required">
            <p class="mb20">1、叶片 （未腐质）：2 ～ 3片，血液（ ≥ 1 mL）、基因组
            DNA（ ≥ 30 μL，浓度 ≥ 30 ng/μL）、纯度 OD 260/280
            在1.7 ～ 1.9 之间；</p>
            <p class="mb20">2、SNP位点信息：人的基因组需SNP位点的RS号；其它物种样品需SNP位点上下游200 bp序列，SNP位点突变类型及位点的上下游200 bp范围是否有其他SNP位点；</p>
            <p>3、动植物：如果没有成熟的目标SNP位点，需做位点筛选后再大样本检测。</p>
          </div>
        </el-col>
      </el-row>
      <div class="c-title">结果交付<small>Delivery Of Results</small></div>
      <p class="tc">提供检测结果统计表和原始检测峰图，提供检测报告（包含方案、流程、峰图）。  </p>
      <div class="tc mt30"><img src="@/assets/images/snp_7.png" class="img-fluid"></div>
      <div class="c-title">相关服务<small>Related services</small></div>
<!--      <ul class="services">-->
<!--        <li><img src="@/assets/images/snp_service_1.png">PCR扩增 </li>-->
<!--        <li><img src="@/assets/images/snp_service_2.png">DNA提取 </li>-->
<!--        <li><img src="@/assets/images/snp_service_3.png">探针合成 </li>-->
<!--        <li><img src="@/assets/images/snp_service_4.png">Sanger测序 </li>-->
<!--        <li><img src="@/assets/images/snp_service_5.png">引物合成 </li>-->
<!--      </ul>-->
      <ul class="effect-lists con">
        <li v-for="(item, index) in types" :key="index" class="pointer" :class="{active: currentType === index}" @mouseover="currentType = index" @mouseout="currentType = -1" @click="$router.push(item.ref)">
          <img :src="`/static/img/Project_${item.img}${currentType===index ? '' : ''}.png`">
          <p style="margin-top: 10px;">{{item.name}}</p>
        </li>
      </ul>
      <div class="cons">
        <ul class="effect-lists " style="display: flex!important;margin-top: 20px;">
          <li v-for="(item, index) in types" :key="index" class="pointer"  @click="$router.push(item.ref)">
            <img :src="`/static/img/Project_${item.img}${currentType===index ? '' : ''}.png`" style="width: 60px;">
            <p style="margin-top: 10px;font-size: 12px">{{item.name}}</p>
          </li>
        </ul>
      </div>

    </section>
    <qk-consult type="Virus"/>
  </div>
</template>
<script>
import bread from "@/components/bread"
export default {
  components: {
    bread,
  },
  data () {
    return {
      currentType:-1,
      types: [
        {name: 'DNA提取', img: '1', ref: '/tec/DNA_extraction'},
        {name: 'PCR扩增', img: '2', ref: '/tec/PCR'},
        {name: 'SSR/STR检测', img: '4', ref: '/tec/SSR'},
      ],
    }
  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/views/tec/SNP.vue